import React from 'react'
import { TestSessionDetailWithResult_testSession } from '@modmd/data'
import Label, { IndicatorColor } from 'components/Label'

interface StatusLabelModel {
  indicator: keyof typeof IndicatorColor
  label: string
}

type PartialSession = Pick<
  TestSessionDetailWithResult_testSession,
  'finishedAt' | 'rejectedAt' | 'isScheduled'
>
interface Props {
  session: PartialSession
}

const getStatusLabelProps: (session: PartialSession) => StatusLabelModel = (session) => {
  if (session.finishedAt) {
    return {
      indicator: 'yellow',
      label: 'Finished',
    }
  }
  if (session.rejectedAt) {
    return {
      indicator: 'grayDark',
      label: 'Rejected',
    }
  }
  if (session.isScheduled) {
    return {
      indicator: 'green',
      label: 'Scheduled',
    }
  }
  return {
    indicator: 'red',
    label: 'Requested',
  }
}

export const TestSessionStatusLabel: React.VFC<Props> = ({ session }) => {
  const statusLabel = getStatusLabelProps(session)
  return (
    <Label size="l" indicator={statusLabel.indicator}>
      {statusLabel.label}
    </Label>
  )
}
